import React, { ReactElement, useContext, useState } from "react";
import Downshift from "downshift";

import { StreetDatasetContext } from "../contexts";
import { StreetSweepingSchedule } from "../models";

interface StreetSelectDropdownProps {
  onSelectionChange: (selection: any) => void;
  handleLookupError: (errorMsg: string | null) => void;
  clearLookup?: boolean;
  inputFieldClassName: string;
}

export default function StreetSearchBox({
  onSelectionChange,
  handleLookupError,
  clearLookup,
  inputFieldClassName,
}: StreetSelectDropdownProps): ReactElement {
  const { dataset } = useContext(StreetDatasetContext);
  const [items, setItems] = useState<Array<StreetSweepingSchedule>>([]);

  return (
    <Downshift
      onChange={onSelectionChange}
      itemToString={(item) =>
        item ? `${item.streetName}, ${item.suburb} ${item.postcode}` : ""
      }
      onInputValueChange={async (inputValue, { isOpen }) => {
        handleLookupError(null);
        if (isOpen && inputValue.length >= 2) {
          const cleanedInput = inputValue
            .trim()
            .toLowerCase()
            .replace(/[^\w\s]/gi, "");
          const matchingItems = dataset.filter((item: StreetSweepingSchedule) =>
            item.streetName.toLowerCase().startsWith(cleanedInput)
          );

          setItems(matchingItems);
          if (matchingItems.length === 0) {
            handleLookupError(
              "No street by that name exists in the Canterbury-Bankstown region."
            );
          }
        } else {
          setItems([]);
        }
      }}
    >
      {({
        getInputProps,
        getItemProps,
        getMenuProps,
        clearSelection,
        highlightedIndex,
        selectedItem,
      }) => {
        if (clearLookup) clearSelection();

        return (
          <div style={{ width: "100%" }}>
            <input
              {...getInputProps({
                onFocus: () => clearSelection(),
              })}
              type="search"
              className={`input ${inputFieldClassName}`}
              placeholder="Enter your street name ..."
              required
            />
            <ul
              {...getMenuProps()}
              style={{
                listStyle: "None",
                position: "absolute",
                zIndex: 100,
              }}
            >
              {items.map((item, index) => (
                <li
                  {...getItemProps({
                    key: `${item.streetName}-${item.suburb}`,
                    index,
                    item,
                    style: {
                      color: "#232a30",
                      padding: "15px",
                      backgroundColor:
                        highlightedIndex === index ? "#F8F8F8" : "white",
                      fontWeight: selectedItem === item ? "bold" : "normal",
                    },
                  })}
                >
                  {item.streetName}, {item.suburb} {item.postcode}
                </li>
              ))}
            </ul>
          </div>
        );
      }}
    </Downshift>
  );
}
